import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_129: FaireProductEntity = {
  token: "legacy_prod_abbott-129",
  type: "product",
  name: "Blue Jay Doormat",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/3b334a682b145b64afe8e6a774e9445c54576a475f685170874a64d870a4e533.jpeg",
  priceDollars: 24,
  subcategory: "Outdoor Decor",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
